<div class="page-wrapper">
  <app-web-navbar></app-web-navbar>

  <!-- 3️⃣ Live Sale Section -->
  <section class="live-sale-section position-relative" *ngIf="liveProductDetails && liveProductDetails.length > 0">
    <div class="container-fluid px-lg-5">
      <div class="eshopper-section-title">
        <span class="line"></span>
        <h3><i class="bi bi-broadcast text-danger me-2"></i>Live Sale</h3>
        <span class="line"></span>
      </div>

      <swiper [config]="liveSaleConfig" class="live-sale-swiper">
        <ng-template swiperSlide *ngFor="let item of liveProductDetails">
          <div class="product-card" (click)="productDetailViewNavigate(item.productId)">
            <div class="product-img-box position-relative">
              <span *ngIf="item.isLive" class="badge bg-danger position-absolute top-0 start-0 m-2"
                style="z-index: 2;"><i class="bi bi-broadcast me-1"></i>Live</span>
              <img [src]="getImageUrl(item.variants)" [alt]="item.productName" loading="lazy"
                (error)="onImageError($event)" />
            </div>
            <div class="product-info">
              <h6 class="product-name">{{ item.productName }}</h6>
              <div class="product-actions">
                <span class="action-link">
                  <i class="bi bi-eye me-1"></i>View Detail
                </span>
              </div>
            </div>
          </div>
        </ng-template>
      </swiper>

      <div class="swiper-button-prev live-sale-prev"></div>
      <div class="swiper-button-next live-sale-next"></div>
    </div>
  </section>


  <!-- 1️⃣ Category Pills Section -->
  <section class="category-pills-section">
    <div class="container-fluid px-lg-5">
      <div class="category-pills-wrapper">
        <div class="category-pill"
             *ngFor="let cat of categoryPills"
             [class.active]="selectedCategoryPill === cat.name"
             (click)="onCategoryPillSelect(cat)">
          <div class="pill-icon">
            <img *ngIf="cat.image" [src]="cat.image" [alt]="cat.name" />
            <i *ngIf="!cat.image" class="bi bi-collection"></i>
          </div>
          <span class="pill-label">{{ cat.name }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- 2️⃣ Category Filtered Products -->
  <section class="products-section" *ngIf="productDetails && productDetails.length > 0">
    <div class="container-fluid px-lg-5">
      <div class="row g-4">
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let a of productDetails">
          <div class="product-card" (click)="productDetailViewNavigate(a.productId)">
            <div class="product-img-box position-relative">
              <span *ngIf="a.isLive" class="badge bg-danger position-absolute top-0 start-0 m-2"
                style="z-index: 2;"><i class="bi bi-broadcast me-1"></i>Live</span>
              <img [src]="getImageUrl(a.variants)" [alt]="a.productName" loading="lazy"
                (error)="onImageError($event)" />
            </div>
            <div class="product-info">
              <h6 class="product-name">{{ a.productName }}</h6>
              <div class="product-actions">
                <span class="action-link">
                  <i class="bi bi-eye me-1"></i>View Detail
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  
  <!-- 4️⃣ Our Collections (All Products) -->
  <section class="products-section">
    <div class="container-fluid px-lg-5">
      <div class="eshopper-section-title">
        <span class="line"></span>
        <h3>Our Collections</h3>
        <span class="line"></span>
      </div>

      <div class="row g-4" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
        (scrolled)="onScrollDown()">
        <!-- No Products Message -->
        <div *ngIf="!allProducts || allProducts.length === 0" class="col-12 text-center py-5">
          <img src="assets/img/icons/empty-product.avif" alt="No Products" width="120" class="mb-3 opacity-75" />
          <h5 class="fw-semibold text-muted mb-1">No Products Found</h5>
          <p class="text-secondary small">
            There are no products available at the moment.
          </p>
        </div>

        <!-- All Product Cards -->
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let a of allProducts">
          <div class="product-card" (click)="productDetailViewNavigate(a.productId)">
            <div class="product-img-box position-relative">
              <span *ngIf="a.isLive" class="badge bg-danger position-absolute top-0 start-0 m-2"
                style="z-index: 2;"><i class="bi bi-broadcast me-1"></i>Live</span>
              <img [src]="getImageUrl(a.variants)" [alt]="a.productName" loading="lazy"
                (error)="onImageError($event)" />
            </div>
            <div class="product-info">
              <h6 class="product-name">{{ a.productName }}</h6>
              <div class="product-actions">
                <span class="action-link">
                  <i class="bi bi-eye me-1"></i>View Detail
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-web-footer></app-web-footer>
</div>